import loadable from '@loadable/component'

import Research from './Research'
import ResearchHighlight from './ResearchHighlight'

export { Research }
export const ResearchItem = loadable(() => import('./ResearchItem'))
export { ResearchHighlight }
export type { ResearchProps } from './Research'
export type {
  ResearchItemRenderLinkProps,
  ResearchItemProps
} from './ResearchItem'
export type {
  ResearchHighlightRenderLinkProps,
  ResearchHighlightProps,
  ResearchHighlightImage
} from './ResearchHighlight'
export { default as researchMocks } from './__mocks__/Research.mock'
